import * as preact from "preact";

interface Props {
  onClose: () => void;
  /** How far through it is, from 0 to 1 (or else `title` in its place) */
  progress?: number;
  title?: string;
  /** At the right: its menu, a streak */
  children?: preact.ComponentChildren;
}

/**
 * The top of a full-screen session (Practice's, classic flashcards, a chat):
 * its ✕ at the left, then how far through it is
 */
export default class SessionHeaderView extends preact.Component<Props> {
  render() {
    const { onClose, progress, title, children } = this.props;
    return (
      <div class="sessionHeader">
        <div class="sessionHeaderContent">
          <button
            type="button"
            class="sessionCloseButton"
            aria-label="Close"
            onClick={onClose}
          >
            <i class="icon icon-remove" aria-hidden="true"></i>
          </button>
          {progress === undefined ? (
            <div class="sessionHeaderTitle">{title}</div>
          ) : (
            <div class="sessionProgress">
              <div
                class="sessionProgressBar"
                style={{ width: `${Math.round(progress * 100)}%` }}
              ></div>
            </div>
          )}
          {children}
        </div>
      </div>
    );
  }
}
